import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'kdu_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const statsApi = {
  getCounters: async () => {
    const res = await axios.get(`${API}/stats/counters`);
    return res.data;
  },
  registerVisit: async () => {
    const res = await axios.post(`${API}/stats/visit`);
    return res.data;
  },
  registerShare: async (platform) => {
    const res = await axios.post(`${API}/stats/share`, { platform });
    return res.data;
  },
};

// Download a protected file (CSV/PDF) via authenticated blob request
export const downloadFile = async (path, fallbackName) => {
  const res = await axios.get(`${API}${path}`, {
    headers: authHeader(),
    responseType: 'blob',
  });
  const disposition = res.headers['content-disposition'] || '';
  const match = disposition.match(/filename=([^;]+)/);
  const filename = match ? match[1].trim() : fallbackName;
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const fundraisingApi = {
  get: async () => {
    const res = await axios.get(`${API}/fundraising`);
    return res.data;
  },
  update: async (data) => {
    const res = await axios.put(`${API}/fundraising`, data, { headers: authHeader() });
    return res.data;
  },
};

export const donationApi = {
  // Public: create a pending infaq record
  create: async (data) => {
    const res = await axios.post(`${API}/donations`, data);
    return res.data;
  },
  // Public: verified donations with dua messages (Wall of Dua)
  messages: async () => {
    const res = await axios.get(`${API}/donations/messages`);
    return res.data;
  },
  // Admin: list all donations (optional status filter)
  list: async (status) => {
    const url = status ? `${API}/donations?status=${status}` : `${API}/donations`;
    const res = await axios.get(url, { headers: authHeader() });
    return res.data;
  },
  // Admin: verify a donation
  verify: async (id) => {
    const res = await axios.put(`${API}/donations/${id}/verify`, {}, { headers: authHeader() });
    return res.data;
  },
  // Admin: reject a donation
  reject: async (id) => {
    const res = await axios.put(`${API}/donations/${id}/reject`, {}, { headers: authHeader() });
    return res.data;
  },
  // Admin: permanently delete a donation (spam)
  remove: async (id) => {
    const res = await axios.delete(`${API}/donations/${id}`, { headers: authHeader() });
    return res.data;
  },
  // Admin: deleted-donations audit log (LHDN reconciliation)
  audit: async () => {
    const res = await axios.get(`${API}/donations/audit`, { headers: authHeader() });
    return res.data;
  },
};

export const authApi = {
  login: async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    if (res.data.access_token) {
      setToken(res.data.access_token);
    }
    return res.data;
  },
  me: async () => {
    const res = await axios.get(`${API}/auth/me`, { headers: authHeader() });
    return res.data;
  },
  logout: () => clearToken(),
};

// Helper to format FastAPI error details safely
export const formatApiError = (detail) => {
  if (detail == null) return 'Sesuatu tidak kena. Sila cuba lagi.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};
